import { SITE } from "../config/siteConfig";

function luminance(hex) {
  const h = hex.replace("#", "");
  const rgb = [0, 2, 4].map((i) => parseInt(h.substring(i, i + 2), 16) / 255);
  const lin = rgb.map((c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)));
  return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2];
}

const DARK_TEXT = "#111827";
const LIGHT_TEXT = "#FFFFFF";

// Couleurs de la page : CTA = couleur primaire du fournisseur, le reste = couleur secondaire.
// Le script de suivi met le numéro en blanc : le bouton du numéro doit donc rester foncé.
export function themeFor(provider) {
  const base = SITE.defaultTheme;
  const primary = (provider && provider.primary) || base.primary;
  const secondary = (provider && provider.secondary) || (provider && provider.primary) || base.secondary;

  const primaryIsLight = luminance(primary) > 0.5;
  const accentIsLight = luminance(secondary) > 0.5;

  return {
    "--primary": primary,
    "--on-primary": primaryIsLight ? DARK_TEXT : LIGHT_TEXT,
    "--number-bg": primaryIsLight ? (provider && provider.secondary) || DARK_TEXT : primary,
    "--accent": accentIsLight ? DARK_TEXT : secondary,
    "--accent-soft": secondary + "1A",
  };
}
